// in src/Settings.js
import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid/Grid";
import Paper from "@mui/material/Paper";

import { REDIRECT_AFTER_NEXT_LOGIN } from "./authProvider";
import logo from "./assets/logo.jpg";
import transplantCover from "./assets/transplant-cover.jpeg";

const DEFAULT_REDIRECT_URL = "/";

const initializeLogin = () => {
	const redirectUrl =
		sessionStorage.getItem(REDIRECT_AFTER_NEXT_LOGIN) ?? DEFAULT_REDIRECT_URL;

	window.location.replace(`/auth/login?redirect_to=${redirectUrl}`);
};

export const LoginPage = () => (
	<Grid container sx={{ height: "100vh", width: "100vw" }}>
		<Grid
			item
			xs={false}
			sm={4}
			md={7}
			sx={{
				backgroundImage: `url(${transplantCover})`,
				backgroundRepeat: "no-repeat",
				backgroundSize: "cover",
				backgroundPosition: "center",
			}}
		/>
		<Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
			<Box
				sx={{
					my: 8,
					mx: 4,
					display: "flex",
					flexDirection: "column",
					alignItems: "left",
					paddingTop: "25%",
					paddingLeft: "10%",
					paddingRight: "10%",
				}}
			>
				<img width="230px" src={logo} alt="Transplantology logo"></img>
				<div
					style={{ marginBottom: "30px", fontSize: "20px", marginTop: "25px" }}
				>
					Please login with your single sign-on credentials to access the organ
					transplant communication system.
				</div>
				<Button
					variant="contained"
					size="large"
					onClick={initializeLogin}
					data-test="login-button"
				>
					Sign in
				</Button>
			</Box>
		</Grid>
	</Grid>
);
